// src/i18n/en/ask.ts
// «Ask» — side panel opened from the app bar. Natural-language questions about
// the person's own hotels; tables and sources are built by the API, and the
// assistant may change the filters of the open screen (with «Undo»).
export const ask = {
  panel: {
    title: 'Ask',
    open: 'Ask Insight',
    close: 'Close',
    intro:
      'Ask about your hotels as you would ask an analyst. You can also ask the screen to show another period or other hotels («show me October»).',
    lookingAt: 'Open screen: %{screen}',
  },

  composer: {
    label: 'Your question',
    placeholder: 'Type your question…',
    send: 'Ask',
    tooLong: 'The question cannot be longer than %{max} characters.',
    newConversation: 'New conversation',
  },

  scope: {
    generic: 'Only the hotels you have access to are queried.',
    count: 'Only the hotel you have access to is queried. |||| Only the %{smart_count} hotels you have access to are queried.',
  },

  suggestions: {
    title: 'You can start with one of these questions',
    filterScreen: 'Show last month’s data on this screen',
    selfService: 'How many hotels were above 50% check-in without the front desk last month?',
    worstPreCheckin: 'Which hotels have the lowest pre-check-in over the last 30 days?',
    evolution: 'How has check-in without the front desk changed compared with the previous month?',
    kioskTime: 'In which hotels does kiosk check-in take longest?',
    charged: 'How much has been charged in self-service this month in each hotel?',
    frontDesk: 'How many check-ins did the front desk do last week according to the reservation system?',
  },

  view: {
    applied: 'Screen updated. %{description}',
    undone: 'Change undone. %{description}',
    undo: 'Undo',
  },

  answer: {
    thinking: 'Querying your hotels’ data…',
    howCalculated: 'How it was calculated',
    source: '%{description}: %{from} to %{to}, %{smart_count} hotel |||| %{description}: %{from} to %{to}, %{smart_count} hotels',
    originRoommatik: 'Roommatik channels',
    originPms: 'Hotel reservation system',
    incomplete: 'The answer may be incomplete: the question needed more queries than allowed. Try narrowing it.',
    disclaimer: 'Answer generated automatically from the data in the table. Check important figures in the table before using them.',
  },

  errors: {
    unavailable: 'The assistant is not available right now. Please try again in a few minutes.',
    rateLimited: 'You have asked many questions in a row. Wait a minute and try again.',
    forbidden: 'Your user does not have access to this feature.',
    invalid: 'Please review the question and try again.',
    generic: 'The question could not be answered. Please try again.',
  },
};

export default ask;
